import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BulkActionFormComponent } from '../MonitoringBulkActionDialog/bulk-action-form.component';


@Component({
    selector: 'agpr-bulk-action-form-renormalize',
    templateUrl: './bulk-action-form-renormalize.component.html',
    styleUrls: ['./bulk-action-form-renormalize.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BulkActionFormRenormalizeComponent),
            multi: true
        }],
    standalone: false
})
export class BulkActionFormRenormalizeComponent extends BulkActionFormComponent implements ControlValueAccessor, OnInit {
    preserveEdit: boolean = true;

    ngOnInit() {
        this.changed();
    }

    writeValue(value: any): void {
        this.preserveEdit = value;
        this.changed();
    }

    changed(): void {
        this.onModelChange(this.preserveEdit);
    }
}
